var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timeDialogContent" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请进行图片验证",
            visible: _vm.timeDialogVisible,
            center: "",
            "show-close": "",
            "custom-class": "timeDialog",
            width: "32%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.timeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "mainContent" },
            [
              _vm.curTimes !== _vm.maxTimes
                ? _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      attrs: { model: _vm.formData, rules: _vm.rules },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "validCode" } },
                        [
                          _c(
                            "div",
                            { staticClass: "validCodeBox" },
                            [
                              _c("el-input", {
                                attrs: {
                                  autocomplete: "off",
                                  size: "medium",
                                  onfocus: "this.removeAttribute('readonly');",
                                  type: "text",
                                  placeholder: "请输入验证码",
                                  maxlength: "20",
                                },
                                model: {
                                  value: _vm.formData.validCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "validCode",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formData.validCode",
                                },
                              }),
                              _c("img", {
                                attrs: { src: _vm.ValidataUrl },
                                on: { click: _vm.getValidata },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "widget rich_text undefined hleft vtop ",
                    staticStyle: {
                      "font-size": "14px",
                      "text-align": "left",
                      "font-weight": "normal",
                      "font-style": "normal",
                    },
                  },
                  [
                    _c("div", { staticClass: "rich-text" }, [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "line-height": "0",
                            "margin-bottom": "5px",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "--mb--rich-text",
                              staticStyle: {
                                "font-family": "SourceHanSansSC",
                                "font-weight": "400",
                                "font-size": "14px",
                                color: "#101010",
                                "font-style": "normal",
                                "letter-spacing": "0px",
                                "line-height": "28px",
                                "text-decoration": "none",
                              },
                              attrs: { "data-boldtype": "0" },
                            },
                            [
                              _vm._v(
                                "考生注意：输入验证码并点击确定将进入正式考试，并记录考试成绩，如未做好准备请取消退出本界面。本次考试120分钟，满分100分，考试开始后即考试计时，如中途退出界面，计时会继续，120分钟后会自动交卷。提前作答完毕，可以提前交卷"
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function () {
                      _vm.timeDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    disabled: _vm.curTimes === _vm.maxTimes,
                    loading: _vm.btnLoading,
                    type: "primary",
                  },
                  on: { click: _vm.confirm },
                },
                [_vm._v(" 确 定 ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }